import moment from "moment";
import React from "react";

import { PhosphorLinkBreakButton } from "components/Atoms/PhosphorIconButton";
import { AppointmentSidePanelPlanner } from "components/SidePanel/Appointment/AppointmentSidePanel";
import { FormatArrivalTime } from "flights/lookup/FlightSearchResult";
import {
  AppointmentPhase,
  Travellers
} from "../../components/";

interface Props {
  canLinkUnlinkTravel: boolean
  appointment: server.dto.PlannerAppointment
  unlink: (appointmentId: number) => void
}

class LinkedTravelRowCard extends React.Component<Props> {
  unlink = () => {
    const { unlink } = this.props;
    unlink(this.getId());
  };

  getId = () => {
    const { appointment } = this.props;
    return appointment.groundTransportId || appointment.trainId || appointment.flightId;
  };

  render(): JSX.Element {
    const {
      appointment,
      canLinkUnlinkTravel
    } = this.props;

    const startDate = moment.utc(appointment.dateStart);
    const endDate = moment.utc(appointment.dateEnd);

    const is24H = !appointment.timeStart.includes("AM") && !appointment.timeStart.includes("PM");

    const dayOfTheMonth = moment.utc(appointment.dateStart).date();
    const shortMonth = moment.utc(appointment.dateStart).format("MMM");
    const shortYear = moment.utc(appointment.dateStart).format("YY");

    const timeDivSize = is24H ? { flex: "0 0 60px" } : { flex: "0 0 80px" };

    return <div>
      <div className="margin-right-small">
        <AppointmentPhase value={appointment.phase} displayLabel={false} />
      </div>
      <div className="flex-column gap grow1">
        <div className="flex gap-small">
          <div className="bigger_text" style={{ flex: "0 0 90px" }}>
            {dayOfTheMonth} {shortMonth} {shortYear}
          </div>

          <div className="big_text" style={timeDivSize}>
            {appointment.timeStart}
          </div>

          <div>
            <div className="margin-top-mini">
              <i className="icon-arrow-right small"></i>
            </div>
          </div>

          <div className="big_text" style={timeDivSize}>
            <FormatArrivalTime departure={startDate} arrival={endDate} />
          </div>

          <AppointmentSidePanelPlanner appointment={appointment}>
            <a onClick={() => { }} className="grow1">
              <b>
                {appointment.sidebarSummary}
              </b><br />
              {appointment.description}
            </a>
          </AppointmentSidePanelPlanner>
        </div>

        {appointment.contacts.length > 0 && <div className="border-top padding-top s1_gray">
          <Travellers travellers={appointment.contacts} />
        </div>}
      </div>

      {canLinkUnlinkTravel && <PhosphorLinkBreakButton
        layout="in-square"
        onClick={this.unlink} />}
    </div>;
  }
}

export default LinkedTravelRowCard;
